import { Link } from 'react-router-dom'
import { Home, ArrowLeft, Sparkles } from 'lucide-react'

const NotFound = () => {
  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-gradient-to-br from-purple-50/50 via-white to-pink-50/50 px-4">
      <div className="text-center max-w-lg">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-purple-100 text-purple-500 mb-6">
          <Sparkles className="w-10 h-10" />
        </div>
        <h1 className="text-6xl md:text-7xl font-serif font-bold text-gray-800 mb-2">404</h1>
        <p className="text-xl text-gray-600 mb-2">Page not found</p>
        <p className="text-gray-500 text-sm mb-8">
          This page might have moved or doesn&apos;t exist. Let&apos;s get you back to your Spa~Radise Luxe experience.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-gradient-to-r from-purple-600 to-pink-600 text-white font-medium shadow-lg hover:shadow-xl hover:scale-105 transition-all"
          >
            <Home className="w-5 h-5" />
            Home
          </Link>
          <button
            type="button"
            onClick={() => window.history.back()}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-xl border-2 border-purple-200 text-purple-700 font-medium hover:bg-purple-50 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            Go back
          </button>
        </div>
      </div>
    </div>
  )
}

export default NotFound
